"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Randomness = void 0;
const ed25519_1 = require("@noble/ed25519");
const uuid_1 = require("uuid");
const crypto = require("crypto");
class Randomness {
    constructor(init) {
        this.salt = init?.salt || Buffer.from(ed25519_1.utils.randomBytes(32));
        this.iv = init?.iv || Buffer.from(ed25519_1.utils.randomBytes(16));
        this.id = init?.id || uuid_1.v4({ random: crypto.randomBytes(16) });
    }
}
exports.Randomness = Randomness;
//# sourceMappingURL=randomness.js.map